<div class="modal-header">
  <h5 class="modal-title">Add members</h5>
</div>
<div class="modal-body">
  <era-security-search-bar [items]="items"
                           (selectedItem)="itemSelected($event)"></era-security-search-bar>
</div>
<div class="modal-footer">
  <button class="btn btn-primary"
          (click)="closeModal()">Cancel</button>
  <button class="btn btn-primary"
          (click)="addMembers()"
          [disabled]="selectedItem === null">Add</button>
</div>